export default __webpack_public_path__ + "static/media/pending.d6481916.svg";